import React from 'react'

const defaultUseCases = [
  {
    title: "Manage service complaints across locations",
    description:
      "Centralize feedback from multiple branches or service points.",
    image: {
      src: '',
      alt: 'Use case preview',
    },
  },
  {
    title: "Capture rural or offline feedback via USSD",
    description:
      "Enable customers without smartphones or internet access to share their voice.",
    image: {
      src: '',
      alt: 'Use case preview',
    },
  },
  {
    title: "Track and celebrate commendations",
    description:
      "Identify teams delivering exceptional service and reward performance.",
    image: {
      src: '',
      alt: 'Use case preview',
    },
  },
  {
    title: "Identify recurring operational issues",
    description:
      "Spot patterns across products, services, or departments.",
    image: {
      src: '',
      alt: 'Use case preview',
    },
  },
];

const FeaturesUseCase = ({ content = {} }) => {
  const title = content.title || 'Use Cases'
  const items = content.items?.length ? content.items : defaultUseCases

  return (
    <section className="bg-[#F7F6FB] py-20 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">

        {/* Section Header */}
        <div className="text-center mb-14" data-aos="fade-up">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            {title}
          </h2>
        </div>

        {/* Grid */}
        <div className="grid gap-8 md:grid-cols-2">
          {items.map((item, index) => (
            <div
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 150}
              className="bg-white rounded-3xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-md transition"
            >
              <div className="w-full h-52 sm:h-60">
                {item.image?.src ? (
                  <img src={item.image.src} alt={item.image.alt || 'Use case preview'} className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full bg-gray-200" />
                )}
              </div>

              {/* Content */}
              <div className="p-6 space-y-3">
                <h3 className="text-lg md:text-xl font-semibold text-gray-900">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm md:text-base">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FeaturesUseCase
